// extracted by mini-css-extract-plugin
module.exports = {"block":"Join_block___87Uy","joinBtn":"Join_joinBtn__mG4VT","header":"Join_header__Fnkdh","highlight":"Join_highlight__e9H2j","pricing":"Join_pricing__WmDNd"};